import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="container-page flex min-h-[60vh] flex-col items-center justify-center py-20 text-center">
      <p className="text-[11px] font-semibold uppercase tracking-wider text-accent">404</p>
      <h1 className="mt-3 text-4xl font-semibold tracking-tight">Page not found</h1>
      <p className="mt-3 max-w-md text-sm text-ink-muted">
        The page you're looking for doesn't exist or has moved. The link may have been from an old
        workshop that's since been canceled.
      </p>
      <Link to="/" className="btn-primary mt-6">
        ← Back to workshops
      </Link>
    </div>
  );
}
